export default "__VITE_ASSET__e1887add__"